import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
export default function MissingScopesMessage({
  missingPortalScopes
}) {
  const scopeFeatures = missingPortalScopes.reduce((final, scope) => {
    const scopeFeatureI18nKey = `marketplace-assets-ui.scopeFeatures.${scope}`;

    if (isValidI18nKey(scopeFeatureI18nKey)) {
      final.push(I18n.text(scopeFeatureI18nKey));
    }

    return final;
  }, []);
  return scopeFeatures.length ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.themes.details.missingPortalScopes",
    options: {
      count: scopeFeatures.length,
      scopeFeatures: I18n.formatList(scopeFeatures)
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.themes.details.missingOtherPortalScopes"
  });
}